/**
 * useReducedMotion — prefers-reduced-motion 미디어 쿼리 감지
 *
 * 모든 animation hook이 이 값을 우선 확인.
 * true일 때 → 모든 애니메이션은 즉시 최종 상태로 snap.
 */
import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)' as const;

function getInitialValue(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(getInitialValue);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia(REDUCED_MOTION_QUERY);

    const handler = (e: MediaQueryListEvent): void => {
      setReduced(e.matches);
    };

    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return reduced;
}
